import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonConfigurationSubscriptionOverview, CommonConfigurationSubscriptionTopics } from "../../CommonComponents/CommonConfigurationSubscriptionViews";
export const ConfigurationSubscriptionsRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.configuration.subscriptions.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationSubscriptionOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationSubscriptionTopics />;
    },
};
